import {
  doGet,
  doPost,
  doPost2,
  doPost2WithFormData,
  tokenPresent as _tokenPresent,
  doPut,
} from 'services/common'

export const tokenPresent = () => {
  return _tokenPresent()
}

const getProfileInfo = () => {
  return doGet('/user/profile')
}

const getSweepsEntries = page => {
  //TODO - This needs to be fixed in common.js
  // const params = {
  //   page: page
  // }

  return doGet(`/user/sweepsEntries?page=${page}`)
}

const getNumberOfSweepsEntryPages = () => {
  return doGet(`/user/numberOfSweepsEntryPages`)
}

const inviteFriend = email => {
  return doPost('/user/mailingList', { email: email })
}

const requestEmailChange = async email => {
  let payload = {
    newEmailAddress: email,
  }

  return doPost2WithFormData(`/user/requestEmailChange`, payload)
}

const confirmEmailChange = async token => {
  let payload = {
    token: token,
  }

  return doPost2WithFormData(`/user/confirmEmailChange`, payload)
}

const getActivity = (page, size) => {
  return doGet(
    `/profile/activities?page=${page}&size=${size}&sort=dateCreated%2CDESC`,
  )
}

const getProfileTable = () => {
  return doGet('/profile')
}

const updateProfile = async profile => {
  return doPost2('/profile', profile)
}

const updateRetailerLastSeen = async retailer => {
  return doPut(`/profile/retailer?lastSeen=${retailer}`)
}

export {
  confirmEmailChange,
  getProfileInfo,
  getSweepsEntries,
  getNumberOfSweepsEntryPages,
  inviteFriend,
  requestEmailChange,
  getActivity,
  updateProfile,
  getProfileTable,
  updateRetailerLastSeen,
}
